import React, { useState, useEffect } from "react";
import useGetListaURL from "../../hooks/useGetListaURL.js";
import ComboSelector, { TipoClave } from "../UI/campos/ComboSelector.js";
import * as UI from "../constantes/UI.js";
import MensajeError from "../UI/MensajeError.js";

const SelectAfectacionIncidencia = (props) => {
  const codigoActual = props.codigoActual;
  const incluirNulo = props.incluirNulo || false;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const setListaAfectaciones = (afectaciones) => {
      if (incluirNulo) {
        setLista([{ codigo: null, descripcion: UI.ITEM_COMBO_VACIO }, ...afectaciones]);
      } else {
        setLista(afectaciones);
      }
    }

    fetchData("partidos/parametros/tipos_incidencia/codigos_afectacion", setListaAfectaciones);
  }, [fetchData, incluirNulo]);

  const onItemElegido = (itemElegido) => {
    props.onAfectacionElegida(itemElegido);
  };

  let valorActual = "";
  if (codigoActual) {
    if (codigoActual.codigo) {
      valorActual = codigoActual;
    } else if (lista.length > 0) {
      for (let i=0; i < lista.length; i++) {
        if (lista[i].codigo.toString() === codigoActual.codigo.toString()) {
          valorActual = lista[i].codigo;
          break;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={valorActual}
        campoClave={TipoClave.CODIGO}
        campoDescripcion="descripcion"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectAfectacionIncidencia;
